import { useUnusedPaidProformaInvoicesQuery } from "@src/__generated__/graphql";
import { onError } from "@src/utils/apollo";
import { InvoiceTypeEnum, useInvoiceStore } from "../store";

export const useFetchUnusedPaidProformaInvoices = () => {
  const store = useInvoiceStore();

  useUnusedPaidProformaInvoicesQuery({
    variables: {
      project_ids: store.form.project_ids.value,
    },
    skip: store.type !== InvoiceTypeEnum.Outgoing,
    onCompleted(data) {
      store.setProformaInvoices(data);
    },
    ...onError(),
  });
};
